import { render, staticRenderFns } from "./SocialDataMJKN.vue?vue&type=template&id=febae4b6&scoped=true"
import script from "./SocialDataMJKN.vue?vue&type=script&lang=js"
export * from "./SocialDataMJKN.vue?vue&type=script&lang=js"
import style0 from "./SocialDataMJKN.vue?vue&type=style&index=0&id=febae4b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febae4b6",
  null
  
)

export default component.exports